import { CommentListController } from "@bakbak/controller";
import * as React from 'react';
import * as isEqual from "react-fast-compare";
import { COMMENT_LIMIT } from '../../../constants';
import { AppContextProps, withAppContext } from '../../../context/AppContext';
import { CommentListView } from './CommentListView';




interface Props {
  postId: string;
}
export class CommentListC extends React.Component<Props & AppContextProps> {
  unsubscribe: () => void;

  shouldComponentUpdate(nextProps: AppContextProps & Props) {
    return !(
      isEqual(this.props.context.commentSort, nextProps.context.commentSort)
      && isEqual(this.props.postId, nextProps.postId)
    )
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {
    const { postId, context } = this.props;
    return (
      <CommentListController postId={postId} limit={COMMENT_LIMIT} sortBy={context.commentSort}>
        {(data) => {
          const { comments, commentListLoading, subscribe, loadMoreComments, hasMore } = data;
          if (commentListLoading) {
            return <div>...loading</div>;
          }
          if (!this.unsubscribe) {
            this.unsubscribe = subscribe();
          }
          if (!comments) {
            return <div />;
          }
          return (
            <div>
              <CommentListView
                commentList={comments}
                fetchMore={loadMoreComments}
                hasMoreComments={hasMore}
              />
              {/* <Button onClick={this.unsubscribe}>Unsubscribe from live comments</Button> */}
            </div>
          );
        }}
      </CommentListController>
    );
  }
}

export const CommentListConnector = withAppContext(CommentListC);



// WEBPACK FOOTER //
// ./src/modules/comment/list/CommentListConnector.tsx